import { ABOUT_TOGGLE_MUTED, ABOUT_TOGGLE_PAUSED } from "./constants";

export const togglePaused = () => ({ type: ABOUT_TOGGLE_PAUSED });
export const toggleMuted = () => ({ type: ABOUT_TOGGLE_MUTED });
